import React from 'react';
import { Button, cn, type ButtonProps } from '@billda/design-system';

export interface PageHeaderActionProps
  extends Omit<ButtonProps, 'children' | 'variant' | 'size'> {
  label: string;
  icon?: React.ReactNode;
  endIcon?: React.ReactNode;
}

export const PageHeaderAction = React.forwardRef<
  HTMLButtonElement,
  PageHeaderActionProps
>(({ label, icon, endIcon, className, ...buttonProps }, ref) => {
  return (
    <Button
      ref={ref}
      variant="ghost"
      size="sm"
      aria-label={label}
      className={cn(
        icon
          ? 'px-1 text-content-secondary sm:px-3 [&_svg]:size-3.5'
          : 'text-content-secondary',
        className
      )}
      {...buttonProps}
    >
      {icon}
      {icon ? <span className="hidden sm:inline">{label}</span> : label}
      {icon ? (
        <span className="hidden sm:inline-flex">{endIcon}</span>
      ) : (
        endIcon
      )}
    </Button>
  );
});

PageHeaderAction.displayName = 'PageHeaderAction';
